import * as ApiManager from './_manager';
import store from '@/store';

export const monetization = {
  listPricing: payload => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/monetization/listPricing`,
      payload
    );
  },
  getPricing: payload => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/monetization/getPricing`,
      payload
    );
  },
  markPaid: (payload) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/payment/markPaid`,
      payload
    );
  },
};
